import styled from 'styled-components';

const RatingAndReviewStyle = styled.div`
	--componentMTop: var(--sp4x);
	--componentItemGap: var(--sp1-5x);
	--footerBtnMTop: var(--sp6x);
	--distanceStarAuto: var(--sp4x);

	.wrapper-content {
		margin-top: var(--componentMTop);
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: var(--componentItemGap);
	}

	.review-btn-block {
		margin-top: var(--footerBtnMTop);
		z-index: 13;
	}

	.revive-link {
		z-index: 12;
	}

	&.reverse {
		.wrapper-starts-text {
			gap: var(--sp1x);
			flex-direction: row-reverse;
		}
	}

	&.button-auto {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;

		.review-btn-block {
			margin-top: 0;
		}

		.wrapper-content {
			--componentItemGap: var(--distanceStarAuto);
		}
	}

	&.color-reverse {
		.color-main {
			path {
				fill: var(--pink1000);
			}
		}
	}

	&.need-help {
		--distanceButtonNeed: var(--sp4x);
		--distanceStarNeed: var(--sp2x);

		flex-direction: column;
		align-items: start;

		.wrapper-content {
			--componentItemGap: var(--distanceStarNeed);
			flex-direction: column;
			align-items: flex-start;
			margin-top: 0;
		}

		.review-btn-block {
			--footerBtnMTop: var(--distanceButtonNeed);
		}
	}

	.color-hover {
		transition: color var(--trTime) ease-out;

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					color: var(--pink1000);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--componentMTop: var(--sp3x);
		--footerBtnMTop: var(--sp4x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceButtonNeed: var(--sp3x);
		--distanceStarAuto: var(--sp2x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceStarAuto: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--footerBtnMTop: var(--sp3x);

		&.button-auto {
			--footerBtnMTop: var(--sp4x);

			display: flex;
			align-items: flex-start;
			flex-direction: column;

			.review-btn-block {
				margin-top: var(--footerBtnMTop);
			}

			.wrapper-content {
				margin-top: var(--sp2x);
			}
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceStarNeed: var(--sp1-5x);
		--distanceStarAuto: var(--sp1-5x);

		&.button-auto {
			--footerBtnMTop: var(--sp3x);
		}
	}
`;

export default RatingAndReviewStyle;
